<template>
  <div>
    <eco-sidebar-dialog
    destroy-on-close
      title="角色接口授权"
      :visible="dialogVisible"
      :before-close="handleClose"
      append-to-body
    >
    <div style="padding: 20px;height: calc(100% - 40px)">
      <eco-table
        v-if="dialogVisible"
        @load="loadMethodData"
        :data="data"
        :pageResult="pageResult"
        :selection="true"
        :default-sorter="[{ direction: 'DESC', property: 'id' }]"
        :default-querys="[
          { property: 'portal_sys_role_auth.ROLE_ALIAS_', value: roleAlias }
        ]"
        :quick-search-props="[
          { prop: 'portal_sys_action.NAME_', label: '名称' },
          { prop: 'portal_sys_action.REQUEST_URL_', label: '请求地址' }
        ]"
        ref="ecoTable"
        :show-custom-column="false"
        :show-export="false"
      >
        <template v-slot:toolbar>
          <el-button-group>
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="showMethodDialog"
              >添加</el-button
            >
            <fe-delete-button
              :url="
                '${portal}/sys/sysRoleAuth/v1/removeRoleMethods?roleAlias=' +
                  roleAlias
              "
              pk="alias"
              parameter="methodAlias"
              :htTable="$refs.ecoTable"
              >删除</fe-delete-button
            >
          </el-button-group>
        </template>
        <template>
          <eco-table-column
            type="index"
            width="50"
            align="center"
            label="序号"
          />
          <eco-table-column prop="id" label="主键" :sortable="true" hidden />
          <eco-table-column
            prop="name"
            label="名称"
            :sortable="true"
            :show-overflow-tooltip="true"
          ></eco-table-column>
          <eco-table-column prop="alias" label="别名" :sortable="true" />
          <eco-table-column
            prop="actionType"
            label="请求方法名"
            :sortable="true"
          />
          <eco-table-column
            prop="requestUrl"
            label="请求地址"
            :sortable="true"
          />
        </template>
      </eco-table>
    </div>
    </eco-sidebar-dialog>
    <!-- 后台接口选择对话框  -->
    <eip-method-dialog
      ref="eipMethodDialog"
      name="eipMethodDialog"
      :role-alias="roleAlias"
      @onConfirm="dialogOnConfirm"
      append-to-body
    />
  </div>
</template>

<script>
const eipMethodDialog = () => import("@/components/dialog/EipMethodDialog.vue");

export default {
  name: "RoleMethodAuth",
  components: {
    eipMethodDialog
  },
  props: {},
  data() {
    return {
      dialogVisible: false,
      roleMenusMethod: null,
      defaultCheckedKeys: [],
      saveData: {},
      roleAlias: null,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 100,
        total: 0
      }
    };
  },
  methods: {
    showMethodDialog() {
      this.$refs.eipMethodDialog.showDialog();
    },
    showDialog(roleAlias) {
      this.dialogVisible = true;
      this.roleAlias = roleAlias;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    loadMethodData(params, cb) {
      this.$http
        .post(
          "${portal}" +
            `/sys/sysMethod/v1/getRoleActions?roleAlias=${this.roleAlias}`,
          params
        )
        .then(response => {
          this.data = response.data.rows;
          this.pageResult = {
            page: response.data.page,
            pageSize: response.data.pageSize,
            total: response.data.total
          };
        })
        .finally(() => cb());
    },
    beforeSaveData() {
      // saveData = {roleAlias:"",arrMenuAlias:[],arrMethodAlias:[],dataPermission:{}}
      var elTree = this.$refs.ecoMenuManager.$refs.ecoMenuTree.$refs.ecoMenuTree
        .$refs.elTree;
      this.saveData = {
        roleAlias: this.roleAlias,
        arrMenuAlias: [
          ...elTree.getHalfCheckedKeys(),
          ...elTree.getCheckedKeys()
        ],
        arrMethodAlias: [],
        dataPermission: {}
      };
    },
    afterSaveData() {
      this.handleClose();
    },
    dialogOnConfirm(methods) {
      if (methods.length) {
        this.$http
          .post("${portal}/sys/sysRoleAuth/v1/saveRoleMethods", {
            roleAlias: this.roleAlias,
            arrMethodAlias: methods.extractByKey("ALIAS_"),
            dataPermission: {}
          })
          .then(response => {
            if (response.data.state) {
              this.$refs.ecoTable.load();
              this.$message({
                type: "success",
                message: response.data.message
              });
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-dialog__body {
  padding: 20px;
}
</style>
